import React from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";

// Define a custom template to place label above the widget
const GIFTemplate = ({ id, label, children, errors, help, description }) => {
  return (
    <div className="form-group" style={{ marginBottom: "15px" }}>
      <label htmlFor={id} style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
        {label}
      </label>
      {description}
      {children}
      {errors}
      {help}
    </div>
  );
};

export default GIFTemplate;
